<template>
	<div class='works'>
		<div class="top">
			<div class="tabList">
				<div
					class="item"
					@click="getList(v,i)"
					:class="{active:i == tabI}"
					v-for="(v,i) in tabList"
					:key="v.name"
				>
					{{ v.name }}
				</div>
			</div>

			<div class="title">
				作品
			</div>
		</div>

		<div
			class="workBox"
			ref="workBox"
			v-loading="loading"
		>
			<div
				class="workList"
				v-for="(v,i) in workList"
				:key="i"
			>
				<div class="title">
					{{ v.titleName || v.productSubject }}
				</div>

				<div
					class="content"
					v-if="v.showType != 3 && tabI != 2"
				>
					{{v.content || ''}}
				</div>

				<div
					class="imageList"
					v-if="v.showType == 3"
				>
					<img
						@click.stop="onImgs(v.imgs,index)"
						v-for="(item,index) in v.imgs.slice(0, 4)"
						:key="index"
						:src="item"
					>
				</div>

				<div
					class="bottom_text"
					v-if="tabI != 2"
				>
					<span>{{ v.readNum || 0}}阅读</span>
					<span>{{ v.commemtNum || 0}}评论</span>
					<span>{{ v.createTime }}</span>
				</div>

				<div
					class="bottom_text"
					v-else
				>
					<span>{{ v.tag }}</span>
					<span>{{ v.updateTime }}</span>
				</div>

				<div
					class="btnBox"
					v-if="tabI != 2"
				>
					<div
						class="operate"
						v-if="v.bizType == 3"
					>
						<img
							:src="v.downloadStatus ? 
              ($store.state.wqurl +'userWorks_open_download.png'):
              ($store.state.wqurl +'userWorks_close_download.png')"
							alt=""
						>

						<span> {{v.downloadStatus ? '关闭下载' : '打开下载'}}</span>
					</div>

					<div class="operate">
						<img
							:src="v.commentStatus ? 
              ($store.state.wqurl +'userWorks_open_comment.png'):
              ($store.state.wqurl +'userWorks_close_comment.png')"
							alt=""
						>

						<span> {{v.commentStatus ? '关闭评论' : '打开评论'}}</span>
					</div>

					<div class="operate">
						<img
							:src="$store.state.wqurl + 
              'userWorks_delete.png'"
							alt=""
						>

						<span>删除</span>
					</div>
					<div class="operate">
						<img
							:src="$store.state.wqurl + 
              'userWorks_setUp.png'"
							alt=""
						>

						<span>设置</span>
					</div>
				</div>
			</div>
		</div>

		<div class="pagination">
			<el-pagination
				@current-change="handleCurrentChange"
				:current-page.sync="page"
				layout="prev, pager, next, jumper"
				:total="total"
			>
			</el-pagination>
		</div>

		<div
			class="previewImg"
			v-if="showPreviewImg"
			@click="showPreviewImg = false"
		>
			<i
				class="el-icon-arrow-left"
				@click.stop="onToggle(imgs.length,true,imgsI)"
			></i>
			<img
				:src="imgs[imgsI]"
				alt=""
			>
			<i
				class="el-icon-arrow-right"
				@click.stop="onToggle(imgs.length,false,imgsI)"
			></i>
		</div>
	</div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import {
  myOriginalWorksPageList,
  showQueryAiWritingResult,
} from "@/api/professionServer";
import qs from "qs";
export default {
  name: "works",
  //import引入的组件需要注入到对象中才能使用
  components: {},
  data() {
    //这里存放数据
    return {
      tabI: 0,
      page: 1,
      tabList: [
        {
          name: "全部",
          fun: this.myOriginalWorksPageList,
        },
        {
          name: "原创",
          type: 3,
          fun: this.myOriginalWorksPageList,
        },
        {
          name: "AI成文",
          fun: this.showQueryAiWritingResult,
        },
        {
          name: "AIGC",
          type: 1,
          fun: this.myOriginalWorksPageList,
        },
      ],
      workList: [],
      total: 0,
      loading: false,
      // 预览图片
      imgs: [],
      imgsI: 0,
      showPreviewImg: false,
    };
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {
    getList(v, i) {
      this.tabI = i;
      v.fun(v);
    },
    // 获取原创列表
    async myOriginalWorksPageList(val, reset = true) {
      try {
        this.loading = true;
        const data = {
          limit: 10,
          page: this.page,
        };

        if (reset) {
          this.page = 1;
          this.workList = [];
        }

        if (val.type) {
          data.type = val.type;
        }

        const res = await myOriginalWorksPageList(data);
        this.loading = false;
        if (res.code == 200) {
          this.workList = res.data.data;
          this.total = res.data.total;
        } else {
          this.$message(res.message);
        }
      } catch (error) {
        this.loading = false;
      }
    },

    //图片预览
    onImgs(imgs, index) {
      this.imgs = imgs;
      this.imgsI = index;
      this.showPreviewImg = true;
    },

    // 图片切换
    onToggle(length, isfront, index) {
      if (isfront) {
        index + 1 == length ? (this.imgsI = 0) : (this.imgsI = index + 1);
      } else {
        index - 1 < 0 ? (this.imgsI = length - 1) : (this.imgsI = index - 1);
      }
    },

    // 分页
    handleCurrentChange(v) {
      this.page = v;
      this.workList = [];
      this.myOriginalWorksPageList(this.tabList[this.tabI], false);
    },

    // ai成文
    async showQueryAiWritingResult(reset = true) {
      try {
        this.loading = true;
        const data = {
          limit: 10,
          page: this.page,
        };
        if (reset) {
          this.page = 1;
          this.workList = [];
        }

        const res = await showQueryAiWritingResult(data);
        this.loading = false;
        if (res.code == 200) {
          this.workList = res.data.data;
          this.total = res.data.total;
        } else {
          this.$message(res.message);
        }
      } catch (error) {
        this.loading = false;
      }
    },
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {
    this.myOriginalWorksPageList({});
  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style lang='scss' scoped>
.works {
  height: 100%;
  .top {
    display: flex;
    align-items: center;
    padding: 15px;
    height: 60px;
    box-sizing: border-box;
    border-bottom: 1px solid #eaeaea;
    justify-content: space-between;
    .title {
      font-weight: bold;
      font-size: 16px;
    }
    .tabList {
      display: flex;
      align-items: center;
      font-size: 15px;
      gap: 20px;
      .item {
        cursor: pointer;
        padding: 10px;
        border-radius: 5px;

        &:hover {
          background: #edf2ff;
          color: #326afb;
        }
      }

      .active {
        background: #edf2ff;
        color: #326afb;
      }
    }
  }
  .workBox {
    height: calc(100% - 100px);
    overflow: auto;
    .workList {
      padding: 15px;
      display: flex;
      flex-direction: column;
      gap: 15px;
      cursor: pointer;
      box-sizing: border-box;
      border-bottom: 1px solid #eaeaea;

      &:hover {
        box-shadow: 0px 0px 15px 3px rgba(193, 193, 193, 0.3);
      }
      .title {
        font-weight: bold;
        font-size: 16px;
      }
      .content {
        font-size: 15px;
        line-height: 1.4;
        text-align: justify;
        overflow: hidden;
        text-overflow: ellipsis;
        -webkit-line-clamp: 4;
        display: -webkit-box;
        -webkit-box-orient: vertical;
      }

      .imageList {
        display: flex;
        align-items: center;
        gap: 10px;

        img {
          border-radius: 10px;
          width: 23%;
        }
      }

      .bottom_text {
        display: flex;
        align-items: center;
        gap: 10px;
        span {
          font-size: 14px;
        }
      }
      .btnBox {
        display: flex;
        align-items: center;
        justify-content: space-between;
        .operate {
          cursor: pointer;
          display: flex;
          align-items: center;
          gap: 8px;
          img {
            width: 15px;
          }
          span {
            font-size: 15px;
          }
        }
      }
    }
  }

  .pagination {
    display: flex;
    height: 40px;
    align-items: center;
    justify-content: center;
  }

  .previewImg {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1;
    gap: 40px;
    box-sizing: border-box;
    background-color: rgba(0, 0, 0, 0.6);

    img {
      height: 65%;
    }

    i {
      color: #fff;
      font-size: 40px;
      cursor: pointer;
      font-weight: bold;
    }
  }
}
</style>